

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Async thunk for updating customer data
export const updateCustomer = createAsyncThunk(
  "client/update-Customer", 
  async ({ userId, updateData }, { rejectWithValue }) => {
    try {
      // Get token from localStorage
      const token = localStorage.getItem("authToken");
      
      if (!token) {
        return rejectWithValue("No authentication token found");
      }
      
      const response = await axios.put(
        `${baseUrl}webuser/api/v1/update-profile`, 
        updateData, 
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
        }
      );
      
      return response.data; // { success: true, message: "Profile updated successfully" }
    } catch (error) {
      console.error("Update customer error:", error);
      return rejectWithValue(
        error.response?.data || 
        error.message || 
        "Failed to update customer"
      );
    }
  }
);

// Async thunk for fetching user profile
export const fetchUserProfile = createAsyncThunk(
  "client/fetch-profile",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("authToken");
      
      if (!token) {
        return rejectWithValue("No authentication token found");
      }

      const response = await axios.get(
        `${baseUrl}webuser/api/v1/profile`,
        {
          headers: {
            "Authorization": `Bearer ${token}`
          },
        }
      );
      
      return response.data; // { success: true, data: { webuser: {...} } }
    } catch (error) {
      return rejectWithValue(
        error.response?.data || 
        error.message || 
        "Failed to fetch profile"
      );
    }
  }
);

const initialState = {
  customer: null,
  loading: false,
  error: null,
  profileData: null,
  profileLoading: false,
  profileError: null,
};

const updateCustomerSlice = createSlice({
  name: "updateCustomer",
  initialState,
  reducers: {
    clearUpdateError: (state) => {
      state.error = null;
    },
    clearProfileError: (state) => {
      state.profileError = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Update customer cases
      .addCase(updateCustomer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCustomer.fulfilled, (state, action) => {
        state.loading = false;
        state.customer = action.payload;
        console.log("Update successful:", action.payload);
      })
      .addCase(updateCustomer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        console.error("Update rejected:", action.payload);
      })
      
      // Fetch profile cases
      .addCase(fetchUserProfile.pending, (state) => {
        state.profileLoading = true;
        state.profileError = null;
      })
      .addCase(fetchUserProfile.fulfilled, (state, action) => {
        state.profileLoading = false;
        state.profileData = action.payload;
        console.log("Profile fetched successfully:", action.payload);
      })
      .addCase(fetchUserProfile.rejected, (state, action) => {
        state.profileLoading = false;
        state.profileError = action.payload;
        console.error("Profile fetch rejected:", action.payload);
      });
  },
});

export const { clearUpdateError, clearProfileError } = updateCustomerSlice.actions;
export default updateCustomerSlice.reducer;
// import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import axios from "axios";
// import { baseUrl } from "../../../../boot";

// // Async thunk for updating customer data
// export const updateCustomer = createAsyncThunk(
//   "client/update-Customer", 
//   async ({ userId, updateData }, { rejectWithValue }) => {
//     try {
//       // Get token from localStorage
//       const token = localStorage.getItem("authToken");
      
//       if (!token) {
//         return rejectWithValue("No authentication token found");
//       }

//       console.log("Updating user with ID:", userId);
//       console.log("Update data:", updateData);
      
//       // Based on your backend, you should be calling an auth-related endpoint
//       // But since you have a separate customer update endpoint, let's use that
//       const response = await axios.put(
//         `${baseUrl}webuser/api/v1/update-profile`, 
//         updateData, 
//         {
//           headers: {
//             "Content-Type": "application/json",
//             "Authorization": `Bearer ${token}` // Add authorization header
//           },
//         }
//       );
//       return response.data;
//     } catch (error) {
//       console.error("Update customer error:", error);
//       return rejectWithValue(
//         error.response?.data || 
//         error.message || 
//         "Failed to update customer"
//       );
//     }
//   }
// );

// const initialState = {
//   customer: null,
//   loading: false,
//   error: null,
// };

// const updateCustomerSlice = createSlice({
//   name: "updateCustomer",
//   initialState,
//   reducers: {
//     clearUpdateError: (state) => {
//       state.error = null;
//     }
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(updateCustomer.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(updateCustomer.fulfilled, (state, action) => {
//         state.loading = false;
//         state.customer = action.payload;
//         console.log("Update successful:", action.payload);
//       })
//       .addCase(updateCustomer.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//         console.error("Update rejected:", action.payload);
//       });
//   },
// });

// export const { clearUpdateError } = updateCustomerSlice.actions;
// export default updateCustomerSlice.reducer;